import { useState, useEffect } from 'react';
import { Cross2Icon } from '@radix-ui/react-icons';

export const TimerButton = ({ onClose }: { onClose?: () => void }) => {
  const [timeLeft, setTimeLeft] = useState(10);
  useEffect(() => {
    if (timeLeft > 0) {
      const timer = setTimeout(() => {
        setTimeLeft(timeLeft - 1);
      }, 1000);
      return () => clearTimeout(timer);
    }
  });
  return timeLeft === 0 ? (
    <Cross2Icon
      className='mb-4 cursor-pointer'
      height={'24'}
      width={'24'}
      onClick={() => {
        if (onClose) onClose();
      }}
    />
  ) : (
    <span className='mb-4 text-nowrap text-right'>Attendi {timeLeft}s</span>
  );
};

export default TimerButton;
